const createTagsOptions = (technologies) => {
  const allTags = [];
  technologies?.map(({ tags }) => tags.map(({ name }) => allTags.push(name)));
  const uniqueTechnologies = Array.from(new Set(allTags));
  return uniqueTechnologies.map((tech) => ({ label: tech }));
};

export default createTagsOptions;
